import { render, staticRenderFns } from "./AccountToken.vue?vue&type=template&id=40cb9cff&scoped=true"
import script from "./AccountToken.vue?vue&type=script&lang=ts"
export * from "./AccountToken.vue?vue&type=script&lang=ts"
import style0 from "./AccountToken.vue?vue&type=style&index=0&id=40cb9cff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb9cff",
  null
  
)

export default component.exports